import { Actions } from '@ngrx/effects';
import { Cart, OrderEntry } from '@spartacus/cart/base/root';

export const LOAD_CHECKOUT_STEP = '[Checkout] Load Checkout Step';
export const LOAD_CHECKOUT_STEP_SUCCESS = '[Checkout] Load Checkout Step Success';
export const SET_DELIVERY_MODE_SUCCESS = '[Checkout] Set Delivery Mode Success'; // Default set delivery mode action

export class LoadCheckoutStep extends Actions {
  readonly type = LOAD_CHECKOUT_STEP;

  constructor(public payload: { step: number, cart: Cart }) {
    super();
  }
}

export class LoadCheckoutStepSuccess extends Actions {
  readonly type = LOAD_CHECKOUT_STEP_SUCCESS;

  constructor(public payload: { step: number, entries: Array<OrderEntry>, optionInformation: any }) {
    super();
  }
}

export type CustomCheckoutStepsEventAction =
  | LoadCheckoutStep
  | LoadCheckoutStepSuccess;
